export type Version<T extends number> = ['version', T];
export const Version = <T extends number>(version: T): Version<T> => [
  'version',
  version,
];
export type Versioned<V extends number, T> = [Version<V>, T];
export const Versioned = {
  of:
    <V extends number, T>(version: V) =>
    (data: T): Versioned<V, T> =>
      [['version', version], data],
  value: <V extends number, T>(versioned: Versioned<V, T>) => versioned[1],
  version: <V extends number, T>(versioned: Versioned<V, T>) => versioned[0][1],
};
export type Mapper<T, R> = (value: T) => R;
export type Upgrade<V extends number, N extends number, T, R> = (
  upgrader: Mapper<T, R>,
) => (previous: Versioned<V, T>) => Versioned<N, R>;
